// extracted by mini-css-extract-plugin
export default {"eventWrapper":"EventWrapperComponent_eventWrapper__D0-9r","eventContent":"EventWrapperComponent_eventContent__hFOcO","inactive":"EventWrapperComponent_inactive__92N4h"};